export default __webpack_public_path__ + "static/media/BackButton.838e5c0a.svg";